import { render } from "./StockCalendar.vue?vue&type=template&id=252ad058&scoped=true"
import script from "./StockCalendar.vue?vue&type=script&lang=js"
export * from "./StockCalendar.vue?vue&type=script&lang=js"

import "./StockCalendar.vue?vue&type=style&index=0&id=252ad058&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252ad058"]])

export default __exports__